module.exports = __webpack_public_path__ + "fonts/Knockout.028d5acf.ttf";